import * as actionTypes from "../ActionTypes";

export const readActiveAgreementsRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.READ_ACTIVE_AGREEMENTS_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const readActiveAgreementsSuccess = (data) => ({
  type: actionTypes.READ_ACTIVE_AGREEMENTS_SUCCESS,
  payload: data,
});

export const readActiveAgreementsFailure = (error) => ({
  type: actionTypes.READ_ACTIVE_AGREEMENTS_FAILURE,
  payload: error,
});

export const saveConsentRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_CONSENT_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveConsentSuccess = (data) => ({
  type: actionTypes.SAVE_CONSENT_SUCCESS,
  payload: data,
});

export const saveConsentFailure = (error) => ({
  type: actionTypes.SAVE_CONSENT_FAILURE,
  payload: error,
});

export const readAgreementsRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.READ_AGREEMENTS_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const readAgreementsSuccess = (data) => ({
  type: actionTypes.READ_AGREEMENTS_SUCCESS,
  payload: data,
});

export const readAgreementsFailure = (error) => ({
  type: actionTypes.READ_AGREEMENTS_FAILURE,
  payload: error,
});

export const saveAgreementRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_AGREEMENT_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveAgreementSuccess = (data) => ({
  type: actionTypes.SAVE_AGREEMENT_SUCCESS,
  payload: data,
});

export const saveAgreementFailure = (error) => ({
  type: actionTypes.SAVE_AGREEMENT_FAILURE,
  payload: error,
});

export const updateAgreementRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_AGREEMENT_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const updateAgreementSuccess = (data) => ({
  type: actionTypes.UPDATE_AGREEMENT_SUCCESS,
  payload: data,
});

export const updateAgreementFailure = (error) => ({
  type: actionTypes.UPDATE_AGREEMENT_FAILURE,
  payload: error,
});

export const deleteAgreementRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.DELETE_AGREEMENT_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const deleteAgreementSuccess = (data) => ({
  type: actionTypes.DELETE_AGREEMENT_SUCCESS,
  payload: data,
});

export const deleteAgreementFailure = (error) => ({
  type: actionTypes.DELETE_AGREEMENT_FAILURE,
  payload: error,
});

export const readConsentAnalyticsRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.READ_CONSENT_ANALYTICS_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const readConsentAnalyticsSuccess = (data) => ({
  type: actionTypes.READ_CONSENT_ANALYTICS_SUCCESS,
  payload: data,
});

export const readConsentAnalyticsFailure = (error) => ({
  type: actionTypes.READ_CONSENT_ANALYTICS_FAILURE,
  payload: error,
});

export const readConsentUsersRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.READ_CONSENT_USERS_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const readConsentUsersSuccess = (data) => ({
  type: actionTypes.READ_CONSENT_USERS_SUCCESS,
  payload: data,
});

export const readConsentUsersFailure = (error) => ({
  type: actionTypes.READ_CONSENT_USERS_FAILURE,
  payload: error,
});

export const readConsentEntityAnalyticsRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.READ_CONSENT_ENTITY_ANALYTICS_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const readConsentEntityAnalyticsSuccess = (data) => ({
  type: actionTypes.READ_CONSENT_ENTITY_ANALYTICS_SUCCESS,
  payload: data,
});

export const readConsentEntityAnalyticsFailure = (error) => ({
  type: actionTypes.READ_CONSENT_ENTITY_ANALYTICS_FAILURE,
  payload: error,
});

export const readConsentEntityDetailsRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.READ_CONSENT_ENTITY_DETAILS_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const readConsentEntityDetailsSuccess = (data) => ({
  type: actionTypes.READ_CONSENT_ENTITY_DETAILS_SUCCESS,
  payload: data,
});

export const readConsentEntityDetailsFailure = (error) => ({
  type: actionTypes.READ_CONSENT_ENTITY_DETAILS_FAILURE,
  payload: error,
});
